import {
  COMPILATION_SUCCESS,
  COMPILATION_ERROR,
  RUNTIME_ERROR,
  CLEAR_RESULT,
} from "./types";
import axios from "axios";

const languageMap = new Map([
  ["C++", 54],
  ["C", 50],
  ["Python", 71],
  ["JavaScript", 63],
  ["Java", 62],
]);

// // Hard Coded Data
// const sample_code =
//   '#include <stdio.h>\n\nint main(void) {\n  char name[10];\n  scanf("%s",name);\n  printf("hello %s\\n",name);\n  return 0;\n}';
// const que_no = 2;

// Api
const api_host = "judge0.p.rapidapi.com";
const api_key = "3eb7b301c5msh7fe0a8c6402dbebp10a12djsn5f9222dfd0ff";
const api_url = "https://judge0.p.rapidapi.com/submissions/";

// TODO:-
// compileProgram/submitProgram will take arguments when submit button will be pressed
// current questions id / language / code

// run code without submitting
export const compileProgram = (code, language, input) => async (dispatch) => {
  try {
    dispatch({
      type: CLEAR_RESULT,
    });
    console.log(input);
    const id = languageMap.get(language);
    const res = await axios({
      method: "POST",
      url: api_url,
      headers: {
        "content-type": "application/json",
        "x-rapidapi-host": api_host,
        "x-rapidapi-key": api_key,
        wait: true,
        accept: "application/json",
        useQueryString: true,
      },

      data: {
        language_id: id,
        source_code: code,
        stdin: input,
      },
    });
    if (res.data.token !== null) {
      let status = await axios({
        method: "GET",
        url: api_url + res.data.token,
        headers: {
          "content-type": "application/octet-stream",
          "x-rapidapi-host": api_host,
          "x-rapidapi-key": api_key,
          useQueryString: true,
        },
      });
      while (status.data.status.description !== "Accepted") {
        status = await axios({
          method: "GET",
          url: api_url + res.data.token,
          headers: {
            "content-type": "application/octet-stream",
            "x-rapidapi-host": api_host,
            "x-rapidapi-key": api_key,
            useQueryString: true,
          },
        });
      }
      if (status.data.stderr !== null) {
        dispatch({
          type: COMPILATION_ERROR,
          payload: status.data.stderr,
        });
      } else if (status.data.stdout !== null) {
        dispatch({
          type: COMPILATION_SUCCESS,
          payload: status.data.stdout,
        });
      } else {
        dispatch({
          type: RUNTIME_ERROR,
          payload: "SERVER ERROR TRY AGAIN",
        });
      }
    }
  } catch (err) {
    dispatch({
      type: RUNTIME_ERROR,
      payload: "SERVER ERROR TRY AGAIN",
    });
  }
};

export const submitProgram = (code, language, prob_id, userName) => async (
  dispatch
) => {
  try {
    dispatch({
      type: CLEAR_RESULT,
    });
    const status = await axios({
      method: "POST",
      url: `/api/problems/${prob_id}/submit`,
      headers: {
        "content-type": "application/json",
      },
      data: {
        code: code,
        language: language,
        userName: userName,
      },
    });
    if (status.data.testcase_result === "Failed") {
      dispatch({
        type: COMPILATION_ERROR,
        payload: status.data.testcase_result,
      });
    } else if (status.data.testcase_result === "Success") {
      dispatch({
        type: COMPILATION_SUCCESS,
        payload: status.data.testcase_result,
      });
    } else {
      dispatch({
        type: RUNTIME_ERROR,
        payload: "RUNTIME_ERROR",
      });
    }
  } catch (err) {
    dispatch({
      type: RUNTIME_ERROR,
      payload: "RUNTIME_ERROR",
    });
  }
};
